import Decimal from '@mixins/decimal';
import Numeral from 'numeral';

export default class Currency {
    constructor(value) {
        this.value = value || value == 0 ? Decimal(value.toString().replaceAll(',', '')) : null;
    }

    static create(value) {
        return new this(value);
    }

    static formatToCurrency(value, symbol, decimalPlaces = 2, divide = true) {
        const instance = new Currency(value || 0);

        return instance.toCurrency(symbol, decimalPlaces, divide);
    }

    static formatToAccounting(value, decimalPlaces = 2, divide = true) {
        const instance = new Currency(value || 0);

        return instance.toAccounting(decimalPlaces, divide);
    }

    toAccounting(decimalPlaces = 2, divide = true) {
        if (!this.value && this.value !== 0) {
            return null;
        }

        let newValue = this.value;

        if (divide) {
            newValue = this.value / 10000;
        }

        let f = '(0,0.00)';

        if (decimalPlaces === 4) {
            f = '(0,0.00[00])';
        }

        return Numeral(newValue).format(f);
    }

    toCurrency(symbol = false, decimalPlaces = 2, divide = true) {
        if (!this.value && this.value !== 0) {
            return null;
        }

        let newValue = this.value;

        if (divide) {
            newValue = this.value / 10000;
        }

        let f = '0,0.00[00]';

        if (decimalPlaces === 2) {
            f = '0,0.00';
        }

        if (symbol) {
            f = `$${f}`;
        }

        return Numeral(newValue).format(f);
    }

    add(value) {
        this.value = this.value.add(value || 0);

        return this;
    }

    format() {
        return Numeral(this.value).format('0,0.00');
    }

    static toInteger(value) {
        return Currency.create(value).toInteger();
    }

    toInteger() {
        return this.value * 10000;
    }

    static formFormat(value, decimalPlaces = 4) {
        const instance = new Currency(value || 0);

        return instance.formFormat(decimalPlaces);
    }

    formFormat(decimalPlaces = 4) {
        if (!this.value && this.value !== 0) {
            return null;
        }
        const newValue = this.value / 10000;

        let f = '0.00[00]';

        if (decimalPlaces === 2) {
            f = '0.00';
        }

        return Numeral(newValue).format(f);
    }
}

export function formatToCurrency(value, decimalPlaces = 2) {
    return Currency.formatToCurrency(value, null, decimalPlaces);
}
export function formatToInteger(value) {
    return Currency.toInteger(value);
}

export function formatToCurrencyWithSign(value, divide) {
    return Currency.formatToCurrency(value, true, 2, divide);
}

export function formatToForm(value, decimalPlaces = 2) {
    return Currency.formFormat(value, decimalPlaces);
}

export function formatToAccounting(value) {
    return Currency.formatToAccounting(value);
}
